<template>
  <el-select v-model="currentLanguage" @change="handleSetLanguage"
             placeholder="语言"
             class="custom-select">
    <el-option label="简体" value="zh"></el-option>
    <el-option label="En" value="en"></el-option>
  </el-select>
</template>

<script>
export default {
  computed: {
    // 获取当前语言
    currentLanguage: {
      get() {
        return this.$i18n.locale; // 从 Vue I18n 获取当前语言
      },
      set(value) {
        this.$i18n.locale = value; // 设置 Vue I18n 的语言
      }
    }
  },
  methods: {
    // 处理语言切换
    handleSetLanguage(lang) {
      this.$store.dispatch('setLanguage', lang); // 更新 Vuex 中的语言
      this.$i18n.locale = lang; // 切换语言
      this.$notify({
        title: this.$t('route.success'),
        message: this.$t('route.languageSwitched'),
        type: 'success'
      });
    }
  }
}
</script>
